// selectedYear.js
// Mặc định năm học 2025-2026 (value = 2025). Khi reload không đổi năm: ưu tiên localStorage (bền khi reload), không dùng currentYear.
import { getFromSessionStorage, saveToSessionStorage } from '@/utils/session'
import { getFromLocalStorage, saveToLocalStorage } from '@/utils/localStorage'

const STORAGE_KEY = 'selectedYear'
const DEFAULT_YEAR = 2025 // Năm học 2025-2026

function getStoredYear() {
    const fromLocal = getFromLocalStorage(STORAGE_KEY)
    if (fromLocal !== null && fromLocal !== undefined) return fromLocal
    const fromSession = getFromSessionStorage(STORAGE_KEY)
    if (fromSession !== null && fromSession !== undefined) return fromSession
    // Chưa có giá trị lưu → dùng mặc định 2025-2026 và lưu luôn để reload không bị chuyển về currentYear
    saveToSessionStorage(STORAGE_KEY, DEFAULT_YEAR)
    saveToLocalStorage(DEFAULT_YEAR, STORAGE_KEY)
    return DEFAULT_YEAR
}

const state = {
    selectedYear: getStoredYear()
}

const mutations = {
    setSelectedYear(state, value) {
        state.selectedYear = value
        saveToSessionStorage(STORAGE_KEY, value)
        saveToLocalStorage(value, STORAGE_KEY)
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
